var indentStyle = {"indentZero":"Y8lHR","indentOne":"ukUri","indentTwo":"c4sp6","indentThree":"IA3OA","indentFour":"RqFX6","indentFive":"-V-kF","indentSix":"uqo18"};

export { indentStyle as i };
//# sourceMappingURL=indentation-ed06192f.js.map
